<header class="assistant-card" [class.assistant-card--mobile]="isMobile()">
  <div class="assistant-card__col1">
    <div class="assistant-card-mascot-ring" aria-hidden="true">
      <app-robocat-mascot-model class="assistant-card-mascot" />
    </div>
  </div>
  <div class="assistant-card__col2">
    <div class="title">{{ 'app.components.parentAiAssistant.title' | translate }}</div>
    <div class="subtitle">
      @if (selectedChild(); as child) {
        <span>{{ 'app.components.parentAiAssistant.subtitleHelpingWith' | translate:{ name: child.name } }}</span>
      } @else {
        <span>{{ 'app.components.parentAiAssistant.subtitleDefault' | translate }}</span>
      }
    </div>
  </div>
  <div class="assistant-card__col3 header-actions">
    @if (!isVerificationMode() && showTopicsButton()) {
      <button
        type="button"
        class="header-action-btn topics-btn"
        (click)="topicsPanelClick.emit()"
        [class.active]="showTopicsPanel()"
      >
        <span class="topics-icon">📋</span>
        @if (filteredTopicsCount()) {
          <span class="topics-count">{{ filteredTopicsCount() }}</span>
        }
      </button>
    }
  </div>
</header>
